/* ==================================================
  獲得予定ポイント（商品詳細）
  - .js-pointReturnLine は初期は「--」。取得に成功したときだけ表示を差し替える
  - .js-pointReturnLine の data-sku / data-price から
    SQ SDK の getEstimatedShopifyCartLineItemPoint を呼び出して表示
  - 価格帯がある商品は data-sku-max / data-price-max も持ち、
    最安・最高バリアントの2件を取得して「最低〜最大」で表示する
===================================================*/

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.SQ === 'undefined') return;
  const sdk = window.sqSDK || new window.SQ.SDK(window.location.origin);

  /* ------------------------------
    ポイント取得
  ------------------------------*/

  const fetchPoints = async (sku, linePrice, quantity) => {
    if (!sku || isNaN(linePrice)) return null;

    /*  Shopify の price は cents 換算（×100）のため /100、line 単価にするため quantity でも割る  */
    const unitPrice = String((linePrice / (quantity * 100)).toFixed(2));

    try {
      const result = await sdk.getEstimatedShopifyCartLineItemPoint(
        'JPY',
        false,
        sku,
        quantity,
        unitPrice
      );
      if (result && result.totalPointsEarning !== undefined) {
        return result.totalPointsEarning;
      }
    } catch (error) {
      console.error('Error fetching line item points:', error);
    }
    return null;
  };

  /* ------------------------------
    表示更新
  ------------------------------*/

  const updateLineItemPoints = async () => {
    const elements = document.querySelectorAll('.js-pointReturnLine');
    if (elements.length === 0) return;

    for (const element of elements) {
      const quantity = parseInt(element.getAttribute('data-quantity') || '1', 10);
      const unit = element.getAttribute('data-points-unit') || '';

      const minPoints = await fetchPoints(
        element.getAttribute('data-sku') || '',
        parseFloat(element.getAttribute('data-price')),
        quantity
      );
      if (minPoints === null) continue;

      /*  価格帯がある商品のみ最高バリアントも取得する  */
      const maxSku = element.getAttribute('data-sku-max') || '';
      const rangeMark = element.getAttribute('data-points-range-mark') || '';
      const maxPoints = maxSku
        ? await fetchPoints(maxSku, parseFloat(element.getAttribute('data-price-max')), quantity)
        : null;

      /*  取得できなかった場合と、算出結果が同じ場合は単一表示に落とす  */
      if (maxPoints === null || maxPoints === minPoints) {
        element.textContent = `${minPoints}${unit}`;
        continue;
      }

      const low = Math.min(minPoints, maxPoints);
      const high = Math.max(minPoints, maxPoints);
      element.textContent = `${low}${rangeMark}${high}${unit}`;
    }
  };

  updateLineItemPoints();
});
